module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../images/food.6762c7ad.svg";